module.exports = __webpack_public_path__ + "static/media/carta_92.89090a79.jpg";